import axiosInstance from "../instance/axiosInstance";

class EstablishmentApi {
  static async establishment() {
    try {
      const response = await axiosInstance.get("/settings/establishment-info");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async editEstablishment() {
    try {
      const response = await axiosInstance.get("/settings/type-and-sectors");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async countyList() {
    try {
        const response = await axiosInstance.get("/settings/countries-cities-list");
        if (response) {
            return response.data;
        }

    } catch (error) {
        return error;
    }
  }
    static async cityList(countryId, page) {
        try {
          const response = await axiosInstance.get(`/settings/country/${countryId}/cities?page=${page}`);
          if (response) {
            return response.data;
          }
        } catch (error) {
          return error;
        }
    }
    static async updateEstablishment(formData) {
        try {
            const response = await axiosInstance.post('/settings/update-establishment', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            return error;
        }
    }
  
}

export default EstablishmentApi;
